module.exports = __webpack_public_path__ + "media/img/home/btn_prev-52ec29e4491ab3592dab448b8df399db.png";